
import AppBar from './app-bar'
import Cm24Footer from './cm24-footer'

export default {
  name: 'Default',
  components: {
    AppBar,
    Cm24Footer
  }
}
